import BaseService from '@/ecm/common/BaseService.js';

class WidgetService {
  baseUrl = 'widget';

  getData = (widget) => BaseService.post({ url: `${this.baseUrl}/get-data`, data: widget });
  getAdditionalData = (widgetAdditionalData) => BaseService.post({ url: `${this.baseUrl}/get-additional-data`, data: widgetAdditionalData });
  getList = () => BaseService.get({ url: `${this.baseUrl}` });
  importLayout = (data) => BaseService.post({ url: `${this.baseUrl}/import-layout`, data: data });
  refreshData = (data) => BaseService.post({ url: `${this.baseUrl}/refresh-data`, data: data });
}

export default new WidgetService();
